export const emailRe = /^([A-Za-z0-9_\-\.\'])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,30})$/;
export const phoneCodeNumberRe = /^([+]|[0-9])[0-9]*$/;
export const passwordRe = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d~!@#$%^&*()_+<>?":`,./;'[\]=\-|\\{}]{8,32}$/;
export const strongPasswordRe = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*()_+<>?":`,./;'[\]=\-|\\{}])[A-Za-z\d~!@#$%^&*()_+<>?":`,./;'[\]=\-|\\{}]{12,32}$/;
export const passwordInputRe = /^[A-Za-z\d~!@#$%^&*()_+<>?":`,./;'[\]=\-|\\{}]+$/;
export const separatorRe = / |,|;|\n|\t|，|；|、/;
